import { render } from "./MyReviews.vue?vue&type=template&id=578f8e3e&scoped=true"
import script from "./MyReviews.vue?vue&type=script&lang=js"
export * from "./MyReviews.vue?vue&type=script&lang=js"

import "./MyReviews.vue?vue&type=style&index=0&id=578f8e3e&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578f8e3e"]])

export default __exports__